var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{staticClass:"position-fixed fixed-top m-2 rounded-0 toast-alert",attrs:{"variant":_vm.variant,"dismissible":""},model:{value:(_vm.show_alert),callback:function ($$v) {_vm.show_alert=$$v},expression:"show_alert"}},[_vm._v("\n    "+_vm._s(this.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }